var createStylesheet = function(chunkId, fullhref, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	2143: 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"2":1,"45":1,"72":1,"139":1,"168":1,"192":1,"204":1,"231":1,"237":1,"295":1,"385":1,"444":1,"482":1,"512":1,"529":1,"652":1,"660":1,"693":1,"706":1,"744":1,"765":1,"812":1,"905":1,"943":1,"1040":1,"1056":1,"1062":1,"1123":1,"1183":1,"1330":1,"1354":1,"1359":1,"1500":1,"1592":1,"1659":1,"1678":1,"1700":1,"1840":1,"1986":1,"2019":1,"2220":1,"2307":1,"2357":1,"2431":1,"2792":1,"2813":1,"2874":1,"3057":1,"3060":1,"3075":1,"3087":1,"3173":1,"3188":1,"3428":1,"3433":1,"3571":1,"3580":1,"3667":1,"3715":1,"3769":1,"3919":1,"4256":1,"4366":1,"4550":1,"4559":1,"4722":1,"4728":1,"4732":1,"4906":1,"4939":1,"5052":1,"5057":1,"5167":1,"5249":1,"5302":1,"5308":1,"5311":1,"5336":1,"5345":1,"5346":1,"5411":1,"5451":1,"5498":1,"5625":1,"5738":1,"5745":1,"5900":1,"5965":1,"6013":1,"6050":1,"6064":1,"6154":1,"6229":1,"6362":1,"6564":1,"6660":1,"6687":1,"6712":1,"6768":1,"6840":1,"6850":1,"6858":1,"6951":1,"7125":1,"7220":1,"7245":1,"7357":1,"7773":1,"7875":1,"7893":1,"7931":1,"7949":1,"8015":1,"8034":1,"8061":1,"8111":1,"8129":1,"8135":1,"8165":1,"8202":1,"8229":1,"8252":1,"8280":1,"8342":1,"8348":1,"8385":1,"8451":1,"8453":1,"8454":1,"8492":1,"8496":1,"8658":1,"8724":1,"8805":1,"9109":1,"9234":1,"9264":1,"9376":1,"9590":1,"9678":1,"9691":1,"9734":1,"9910":1,"9938":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr